// JavaScript files are compiled and minified during the build process to the
// assets/built folder. See the scripts in package.json.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import intro from "./intro";
import initials, { initialsIn } from "./initials";
import toc from "./toc";
import traceReveal from "./reveal";

menuOpen();
intro();
initials();
toc();
traceReveal();
infiniteScroll(initialsIn);
